/**
 * A plugin's own page, under the organization. `connections_` (trailing
 * underscore) keeps it a sibling of the catalogue rather than a child, so
 * the detail page owns the whole surface.
 *
 * @module routes/$org.connections_.$pluginId
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { PluginDetailPage } from "../components/connections/PluginDetailPage";

export const Route = createFileRoute("/$org/connections_/$pluginId")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: PluginDetailPage,
});
